import React from 'react'
import * as classes from './AwardCard.module.scss'
function AwardCard({ year, title, text, image, imageAlt, badgeWidth, headingLevel: Heading = 'h3' }) {
    const style = badgeWidth ? { '--award-badge-natural': `${badgeWidth}px` } : undefined

    return (
        <article className={classes.Card} style={style}>
            {image ? <img className={classes.Badge} src={image} alt={imageAlt || ''} /> : null}

            <div className={classes.Content}>
                {year ? <p className={classes.Year}>{year}</p> : null}

                {title ? <Heading className={classes.Title} dangerouslySetInnerHTML={{ __html: title }} /> : null}

                {text ? <p className={classes.Body} dangerouslySetInnerHTML={{ __html: text }} /> : null}
            </div>
        </article>
    )
}

export default AwardCard
